import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { ref: "widget" }
const _hoisted_2 = ["data-fit"]
const _hoisted_3 = { class: "ButtonIconWidget" }
const _hoisted_4 = {
  key: 0,
  class: "FitText"
}
const _hoisted_5 = {
  key: 1,
  class: "ButtonMatchWidget"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isFullProfile || !_ctx.bestFitScore)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args))),
          "data-fit": _ctx.bestFitScore,
          class: "ButtonWidget js-Widget"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "BestFitLogo" }, [
              _createElementVNode("i", { class: "BestFitIcon lnr-percent" })
            ], -1 /* HOISTED */)),
            (_ctx.hasEmptyText || (_ctx.isFullProfile && _ctx.userLoggedIn))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Check Your Fit "))
              : _createCommentVNode("v-if", true)
          ])
        ], 8 /* PROPS */, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(["Red", _ctx.fitColor])
          }, _toDisplayString(_ctx.bestFitScore) + "% Match ", 3 /* TEXT, CLASS */)
        ]))
  ], 512 /* NEED_PATCH */))
}